export enum AutomationMode {
  SENTENCE = "sentence",
  WORD = "word",
  DIALOGUE = "dialogue",
  WORD_SENTENCE = "word_sentence",
  COURSE_DIALOGUE = "course_dialogue",
}

export enum AutomationJobStatus {
  PENDING = "pending",
  PROCESSING = "processing",
  DONE = "done",
  ERROR = "error",
  CANCELLED = "cancelled",
}

export interface AutomationLanguageInfo {
  code: string;
  name: string;
  supports_google: boolean;
  supports_deepl: boolean;
}

export interface ProcessResponse {
  job_id: string;
}

export interface JobStatusResponse {
  job_id: string;
  status: AutomationJobStatus;
  progress: number;
  mode: AutomationMode;
  language: string;
  error_message: string | null;
}

export interface JobListItem {
  job_id: string;
  status: AutomationJobStatus;
  progress: number;
  mode: AutomationMode;
  language: string;
  source_filename: string | null;
  total_rows: number;
  created_at: string;
  error_message: string | null;
}

export interface JobListResponse {
  jobs: JobListItem[];
  total: number;
  limit: number;
  offset: number;
}

export interface AutomationPrompt {
  slug: string;
  title: string;
  description: string;
  content: string;
  updated_at: string;
}

export interface UpdatePromptPayload {
  title?: string;
  description?: string;
  content?: string;
}
